export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100 pt-14 md:pt-20 pb-6 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <span className="text-xl font-heading font-bold text-background-50">八戒影视</span>
            <p className="text-sm text-background-300 mt-3 leading-relaxed">
              八戒影视网提供最新高清电影、热播电视剧、热门综艺和动漫免费在线观看。
              无需付费即可畅享全集完整版，播放流畅不卡顿，秒速加载不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '最新更新', href: '#updates' },
                { label: '平台优势', href: '#features' },
                { label: '精彩推荐', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">内容分类</h4>
            <div className="flex flex-col gap-2">
              {['高清电影', '电视剧全集', '热门综艺', '人气动漫', '纪录片', '动作大片'].map((l) => (
                <a
                  key={l}
                  href="#index"
                  className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {l}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400">暂无合作伙伴信息</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 八戒影视网. 高清电影电视剧全集免费在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-400 whitespace-nowrap">八戒影视在线看</span>
            <span className="text-xs text-background-400 whitespace-nowrap">不缓冲秒播</span>
          </div>
        </div>
      </div>
    </footer>
  );
}